<template>
  <div class="grid-header p-2">
    <div class="d-flex align-items-center">
      <span
        v-if="gridtitle"
        v-testing="qa"
        class="grid-header__title font-weight--medium pl-3"
      >
        {{ gridtitle }}
      </span>
      <span
        v-if="gridcategory"
        class="grid-header__title font-weight--medium"
      >
        <i
          class="far fa-chevron-right px-2"
          aria-hidden="true"
        />
        {{ gridcategory }}
      </span>
      <span
        v-if="gridsubtitle"
        class="grid-header__subtitle d-md-none d-lg-flex pl-3"
      >{{ gridsubtitle }}</span>
      <slot name="custom-title" />
    </div>
    <div class="grid-header__actions">
      <b-row class="d-flex justify-content-end mr-2">
        <slot />
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
    name: 'GridHeader',
    props: {
        gridtitle: String,
        gridsubtitle: String,
        gridcategory: String,
        qa: String
    }
}
</script>

<style scoped lang="scss">
.sr-panel-mid-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
}

.sr-panel-nav {
  .nav-link {
    color: $base-text-color;
    border-bottom: 1px solid #d8d8d8;
    &.active {
      color: $header-text-color;
      border-bottom: 1px solid black;
    }
    &:hover {
      color: $header-text-color;
    }
  }
}

.sr-panel-filters {
  display: flex;
  align-items: center;
  flex-grow: 1;
  min-height: 30px;
  padding-right: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid vt-color(general-border);
  & > :not(:last-child) {
    margin-right: 45px;
  }
  .sr-panel-end {
    margin-left: auto;
  }
}

.filter-label {
  margin-right: 0.5rem;
  font-size: font-size(small);
}

.sr-panel-filters span {
  font-size: 0.8rem;
  text-transform: uppercase;
}
</style>
